export const AZURE_DEVOPS_PROVIDER = 'azure';
export const AZURE_DEVOPS_GLOBAL_TOKEN_KEY = 'azure-devops-token';

export function getAzureDevOpsTokenKey(organization: string): string {
  return `${AZURE_DEVOPS_GLOBAL_TOKEN_KEY}:${organization
    .trim()
    .toLowerCase()}`;
}

export function getAzureDevOpsOrganization(
  repoUrl: string,
): { host: string; organization: string } | undefined {
  const url = new URL(repoUrl.includes('://') ? repoUrl : `https://${repoUrl}`);
  const parts = url.pathname.split('/').filter(Boolean);
  const organization = url.hostname.endsWith('.visualstudio.com')
    ? url.hostname.slice(0, -'.visualstudio.com'.length)
    : (parts[0] === 'tfs' ? parts[1] : parts[0]) ??
      url.searchParams.get('organization');
  return organization
    ? {
        host: url.host.toLowerCase(),
        organization: decodeURIComponent(organization).trim().toLowerCase(),
      }
    : undefined;
}
